var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBorderDashedLarge = function SvgBorderDashedLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 10,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2 2h6v6H5a3 3 0 0 1-3-3zM12 2h8v6h-8zM24 2h8v6h-8zM36 2h6v3a3 3 0 0 1-3 3h-3z"
  })));
};
export { SvgBorderDashedLarge as ReactComponent };
export default __webpack_public_path__ + "092db8ed01b90779f541c6e55c98e3c1.svg";